import { BaseModel } from '../base.model'
import { Section } from './section.model'
  
export class SectionGrade extends BaseModel<SectionGrade>{
  static DEFAULT_ATTRIBUTES = {
  }

  id: number
  sectionId: number
  maxScore: number
  minScore: number
  grade: number
  _destroy: boolean
  comment: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exams/section-grade.model.ts